/**
 * Copyright © 2026 Adnuntius AS.
 */
import {UIRouter} from '@uirouter/core';

export interface AdminResourceRouteContext {
  model: any;
  modelComms: any;
  isNew: boolean;
  readOnly: boolean;
  blockDelete?: any;
  confirmation?: any;
  copyConfig?: any;
}

function getTransitionInjector(uiRouter: UIRouter): any {
  return uiRouter.globals.successfulTransitions.peekTail()?.injector();
}

function getResolved(injector: any, key: string): any {
  if (!injector) {
    return undefined;
  }

  try {
    return injector.get(key);
  } catch (e) {
    return undefined;
  }
}

export function readAdminResourceRouteContext(uiRouter: UIRouter): AdminResourceRouteContext {
  const injector = getTransitionInjector(uiRouter);
  const routeParams = uiRouter.globals.params;
  const model = getResolved(injector, 'model');
  const modelComms = getResolved(injector, 'modelComms');
  const readOnlyValue = getResolved(injector, 'readOnly');

  return {
    model,
    modelComms,
    isNew: !!routeParams.isNew,
    readOnly: !!readOnlyValue,
    blockDelete: getResolved(injector, 'blockDelete'),
    confirmation: getResolved(injector, 'confirmation'),
    copyConfig: getResolved(injector, 'copyConfig')
  };
}
